import { render, staticRenderFns } from "./TmFormStruct.vue?vue&type=template&id=7f59745c&scoped=true&"
import script from "./TmFormStruct.vue?vue&type=script&lang=js&"
export * from "./TmFormStruct.vue?vue&type=script&lang=js&"
import style0 from "./TmFormStruct.vue?vue&type=style&index=0&id=7f59745c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59745c",
  null
  
)

export default component.exports